import React from 'react';
import Layout from './Shared/Layout';
import Hero from '../Components/Hero';
import Callout from '../Components/Callout';
// import News from '../Components/News';
import Guests from '../Components/Guests';
import { Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

class Main extends React.Component {

    componentDidMount() {

        window.scrollTo(0, 0);
        this.hideIcon();
    }

    hideIcon() {
        let gachapon = document.getElementById("gachapon");

        if (gachapon) gachapon.style.display = "none";
    }

    render() {

        return (
            <>
                <style dangerouslySetInnerHTML={{
                    __html: `
                    #gachapon { display: none !important; }
                    `}} />
                <Layout className="position-relative">
                    <ScrollBtns />
                    <Hero />
                    <Callout />
                    {/* <News /> */}
                    <Guests />
                    <Row className="flex-column text-center pb-5 pt-0 bg-black justify-content-center">
                        <div className="section-title mb-5">
                            <h1><span className="px-3">Archive</span></h1>
                        </div>
                        <div>
                            <a href="/archive/2020/index.html" target="_blank" className="btn btn-primary rounded-pill">
                                <strong>At Home</strong> 2020
                            </a>
                        </div>
                    </Row>
                </Layout>
            </>
        );
    }
}

function scrollToSection(target) {

    let pos = target === "top" ? 0 : document.getElementById(target).offsetTop - 120;

    window.scrollTo(0, pos);

}

const ScrollBtns = () => {
    return (
        <>
            {/*<div className="row justify-content-center bg-black pb-4">

                 <Button
                    onClick={() => scrollToSection("newsSection")}
                    variant="dark"
                    size="xs"
                    className="text-white mx-2 rounded-pill">
                    News<span> &amp; Articles</span>
                </Button> 
                <Button
                    onClick={() => scrollToSection("guestSection")}
                    variant="dark"
                    size=""
                    className="text-white mx-2 rounded-pill">
                    <span>Special </span>Guests
                </Button>
            </div>*/}
            <div
                id="upArrow"
                onClick={() => scrollToSection("top")}
                style={{
                    position: "fixed",
                    bottom: 60, right: "5%",
                    cursor: "pointer",
                    zIndex: 100,
                    backgroundColor: "black",
                    borderRadius: 16,
                    width: 30,
                    height: 30,
                    overflow: "visible"
                }}
                className="">
                <FontAwesomeIcon
                    style={{ width: 32, height: 32, color: "#96f500", }}
                    icon={faArrowCircleUp}
                />
            </div>
        </>
    )
}

export default Main;


